import React from 'react'
import { Box } from '@mui/joy';
import { useThemeContext } from '../../context/ThemeContext';
import HeaderTwo from '../../component/header/HeaderTwo';
import Footer from '../../component/footer/Footer';

import Breadcrumb from '../../component/common/Breadcrumb';
import AppliedJobCard from '../../element/card/fundi/AppliedJobCard';


const AppliedJob = () => {
  const { isSM, isMd, isMD,isLg } = useThemeContext()
  return (
    <>
      <Box
        sx={{
          width: isSM ? '100%' : isMd ? '100%' : isLg ? '100%' : '100%',
          padding: '0',
          boxSizing: 'border-box',
        }}
      >
        <HeaderTwo />
        <Breadcrumb parent="Home" title="Bid" />
        <Box
          sx={{
            width: isSM ? '100%' :isMD ? '100%' : isMd ? '1007px' : isLg ? '1207px' : '1207px',
            padding:  isSM ? '1rem' :isMD ? '2rem' : isMd ? '10px' :0,
            margin:'0 auto',
            boxSizing: 'border-box',
          }}
        >
          <AppliedJobCard/>
        </Box>

        <Footer />
      </Box>


    </>
  )
}

export default AppliedJob;